"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Language = void 0;
var Language;
exports.Language = Language;

(function (Language) {
  Language["en"] = "en";
  Language["fr"] = "fr";
  Language["de"] = "de";
  Language["es"] = "es";
  Language["it"] = "it";
  Language["nl"] = "nl";
  Language["pt"] = "pt";
  Language["zh"] = "zh";
})(Language || (exports.Language = Language = {}));